import React from 'react'
import { AnyAction } from 'redux'
import { useDispatch } from 'react-redux'
import { subscribe } from 'react-contextual'
import OnboardingProvider from '../../OnboardingProvider'
import styles from './GetStarted.module.scss'
import ControlledTooltip from '../../../../views/components/atoms/Tooltip/ControlledTooltip'

interface GetStartedStep {
  title: string
  description: string
  route: string
  complete: boolean
  isDisabled?: boolean
}

interface GetStartedProps {
  redirect: (path: string) => AnyAction
  getStartedSteps: GetStartedStep[]
}

const GetStarted = ({ redirect, getStartedSteps }: GetStartedProps) => {
  const dispatch = useDispatch()

  return (
    <div className={styles.root}>
      <h2>Get Started</h2>
      <p>Follow these four easy steps and we’ll have you up and running in just a few minutes.</p>

      {getStartedSteps.length > 0 && (
        <ol className={styles.steps}>
          {getStartedSteps.map((step: GetStartedStep, i: number) => {
            const handleClick = () => (step.isDisabled ? () => {} : dispatch(redirect(step.route)))
            const body = (
              <div>
                <button onClick={handleClick} className={step.isDisabled ? styles.disabled : ''}>
                  <h3>{step.title}</h3>
                  {!step.complete && <p>{step.description}</p>}
                </button>
              </div>
            )

            return (
              <li className={step.complete ? styles.complete : undefined} key={i}>
                {step.isDisabled ? (
                  <ControlledTooltip body="Please complete step 1 and 2." place="above">
                    {body}
                  </ControlledTooltip>
                ) : (
                  body
                )}
              </li>
            )
          })}
        </ol>
      )}
    </div>
  )
}

export default subscribe(OnboardingProvider, ({ redirect, getStartedSteps }: GetStartedProps) => ({
  redirect,
  getStartedSteps,
}))(GetStarted)
